export default {
  lookupTablesAppName: { id: 'lookup_tables_app_name' },
  noTablesMessage: { id: 'no_tables_message' },
  createTableMessage: { id: 'create_table_message' },
  newTable: { id: 'new_table' },
  tableName: { id: 'table_name' },
  columns: { id: 'columns' },
  addColumn: { id: 'add_column' },
  createButton: { id: 'create_button' },
  column: { id: 'column' },
  successLookupTableCreation: { id: 'success_lookup_table_creation' },
  failureLookupTableCreation: { id: 'failure_lookup_table_creation' },
  title: { id: 'title' },
  status: { id: 'status' },
  createdBy: { id: 'createdBy' },
  dateCreated: { id: 'date_created' },
  modifiedBy: { id: 'modified_by' },
  dateUpdated: { id: 'date_updated' },
  cancel: { id: 'cancel' },
  delete: { id: 'delete' },
  deleteColumn: { id: 'delete_column' },
  deleteTableDialogMessage: { id: 'delete_table_dialog_message' },
  deleteTableDataDialogMessage: { id: 'delete_table_data_dialog_message' },
  deleteTableSuccessMessage: { id: 'delete_table_success_message' },
  deleteTableErrorMessage: { id: 'delete_table_error_message' },
  publish: { id: 'publish' },
  unpublish: { id: 'unpublish' },
  update: { id: 'update' },
  lookupTableActionMessage: { id: 'lookup_table_action_message' },
  lookupTableActionSuccessMessage: {
    id: 'lookup_table_action_success_message',
  },
  lookupTableActionErrorMessage: { id: 'lookup_table_action_error_message' },
  newRow: { id: 'new_row' },
  newColumn: { id: 'new_column' },
  addRow: { id: 'add_row' },
  add: { id: 'add' },
  rowActionSuccessMessage: { id: 'row_action_success_message' },
  rowActionErrorMessage: { id: 'row_action_error_message' },
  tableUnpublishConfirmationMessage: {
    id: 'table_unpublish_confirmation_message',
  },
  filters: { id: 'filters' },
  published: { id: 'published' },
  draft: { id: 'draft' },
  noResultsMessage: { id: 'no_results' },
  addFilter: { id: 'add_filter' },
  activeFilters: { id: 'active_filters' },
  start: { id: 'start' },
  end: { id: 'end' },
  oneDay: { id: 'one_day' },
  threeDays: { id: 'three_days' },
  oneWeek: { id: 'one_week' },
  twoWeeks: { id: 'two_weeks' },
  oneMonth: { id: 'one_month' },
  search: { id: 'search' },
  sort: { id: 'sort' },
}
